import React from 'react';
import { Link, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

const Company = (props) => {
  Company.propTypes = {
    data: PropTypes.object
  };

  const { jobId } = useParams();

  return (
    <div className="corporate-structure-blocks company">
      <h4>
        Company
        <Link to={'/job/' + jobId + '/group-setup/members/edit/' + props.data?.id}>
          <button type="button" className="fa fa-edit"></button>
        </Link>
      </h4>
      <table cellPadding="0" cellSpacing="0" width="100%">
        <tr>
          <td width="34%">Legal Name</td>
          <td colSpan="2">{props.data.name}</td>
        </tr>
        <tr>
          <td>ACN</td>
          <td colSpan="2">{props.data?.additional_info?.acn}</td>
        </tr>
        <tr>
          <td>ABN</td>
          <td colSpan="2">{props.data?.additional_info?.abn}</td>
        </tr>
        <tr>
          <td>Trading Name</td>
          <td colSpan="2">{props.data?.additional_info?.trading_name}</td>
        </tr>
        <tr>
          <td>Activity</td>
          <td colSpan="2">{props.data.activity}</td>
        </tr>
        {props.data?.directors?.map((item, index) => {
          return (
            <tr key={index}>
              <td>Director</td>
              <td colSpan="2">{item?.label}</td>
            </tr>
          );
        })}
        {props.data?.shareholders?.map((item, index) => {
          return (
            <tr key={index}>
              <td>Shareholder</td>
              <td>{item?.name?.label}</td>
              <td width="18%">
                {item?.holding}
                {item?.holding ? '%' : ''}
              </td>
            </tr>
          );
        })}
      </table>
      {/* <ul>
        <li>
          <label>Legal Name</label>
          <p>{props.data.name}</p>
        </li>
        <li>
          <label>ACN</label>
          <p>{props.data?.additional_info?.acn}</p>
        </li>
        <li>
          <label>ABN</label>
          <p>{props.data?.additional_info?.abn}</p>
        </li>
        <li>
          <label>Trading Name</label>
          <p>{props.data?.additional_info?.trading_name}</p>
        </li>
        <li>
          <label>Activity</label>
          <p>{props.data.activity}</p>
        </li>
        {props.data?.directors?.map((item, index) => {
          return (
            <li key={index}>
              <label htmlFor="">Director</label>
              <p>{item?.label}</p>
            </li>
          );
        })}
        {props.data?.shareholders?.map((item, index) => {
          return (
            <li key={index}>
              <label htmlFor="">Shareholder</label>
              <p>{item?.name?.label}</p>
              <p>
                {item?.holding}
                {item?.holding ? '%' : ''}
              </p>
            </li>
          );
        })}
      </ul> */}
    </div>
  );
};

export default Company;
